<template>
	<core-modal
		name="create-campaign-modal"
		class="omapi-modal create-campaign-modal"
		:clickToClose="!isCreatingCampaign"
		:childRefs="$refs"
		headerText="Create Campaign"
	>
		<modals-content>
			<form @submit.prevent="doCreate">
				<label for="campaignName">What do you want to call your campaign?</label><br>
				<input
					type="text"
					name="campaignName"
					class="omapi-input"
					placeholder="My WordPress Campaign"
					v-model="name"
					@keydown.esc="name=''"
					ref="toFocus"
				/>
				<br>
				<core-loading-button
					color="blue"
					type="primary"
					:loading="isCreatingCampaign"
					buttonType="submit"
				>
					Start Building
				</core-loading-button>
			</form>
		</modals-content>
	</core-modal>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
	data () {
		return {
			isCreatingCampaign : false,
			name               : null,
			error              : null,
		}
	},
	computed : {
		...mapState('templates', {
			template : 'activeTemplate',
		}),
		campaignData () {
			return {
				name     : this.name || 'My WordPress Campaign',
				sites    : [ this.$siteId ],
				template : this.template.id,
				type     : this.template.type,
			}
		},
	},
	methods : {
		...mapActions('campaigns', [ 'createCampaign' ]),
		doCreate () {
			if (this.isCreatingCampaign) {
				return false
			}

			this.isCreatingCampaign = true
			this.createCampaign(this.campaignData)
				.then(({ id }) => {
					window.location.href = this.$urls.builderLink(id, 'edit/?isNew=true')
				}).catch((e) => {
					this.$modal.hide('create-campaign-modal')
				})
		},
	},
}
</script>
